<template>
  <default-modal
    v-model="modalOpened"
    name="customer-export-modal"
    :title="$t('export_partner_modal_title')"
    :actionLabel="$t('export')"
    :successHandler="success ? null : handleExport"
  >
    <template slot="content">
      <div v-if="!success">
        <p>{{ $t('export_partner_modal_body') }}</p>

        <q-field :label="$t('format')" :labelWidth="4">
          <q-select v-model="formData.format" :options="customerExportFormats"/>
        </q-field>
      </div>

      <div v-else>
        <check-mark></check-mark>
        <h4 class="text-center">{{ $t('export_successful_title') }}</h4>
        <p class="text-center">{{ $t('export_successful_body') }}</p>
      </div>
    </template>

    <q-inner-loading :visible="loading"></q-inner-loading>
  </default-modal>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import CheckMark from 'components/Common/Animations/Checkmark.vue'
  import { CustomersClient } from 'src/api/Customers'
  import DefaultModal from 'components/Modal/DefaultModal.vue'
  import { createErrorFromResponse } from 'src/utils/error'
  import { customers } from 'src/config'

  export default {
    data () {
      return {
        loading: false,
        success: false,
        formData: {
          format: 'vcard'
        }
      }
    },

    computed: {
      ...mapGetters(['customerExportModalOpened']),

      modalOpened: {
        get () {
          return this.customerExportModalOpened
        },

        set (value) {
          if (value) {
            return
          }

          this.closeCustomerExportModal()

          this.loading = false
          this.success = false
        }
      },

      customerExportFormats () {
        return customers.export_formats
      }
    },

    methods: {
      ...mapActions(['closeCustomerExportModal']),

      handleExport () {
        this.loading = true

        new CustomersClient()
          .exportAll(this.formData.format)
          .then(() => {
            this.loading = false
            this.success = true
          })
          .catch(error => {
            this.loading = false

            createErrorFromResponse(error)
          })
      }
    },

    components: {
      CheckMark,
      DefaultModal
    }
  }
</script>
